<template>
    <div class="popup nums__plan nums__popup">
        <div class="modal-header">
            <button type="button" class="close ui ui-cross" @click="close"></button>
        </div>
        <div class="nums__popup-header">
            <div class="container">
                <div class="nums__popup-title">
                    Выбор тарифа
                </div>
            </div>
        </div>
        <div class="nums__popup-body">
            <div class="container">
                <template v-if="provider.logo">
                    <img
                            class="nums__logo"
                            :src="provider.logo"
                            :alt="'Тарифы на номера предоставлены ' + provider.name"
                    >
                </template>
                <p>
                    Платить по выбранным тарифам вы будете в компанию {{ provider.name }}.
                </p>
                <div
                        class="nums__row"
                        :key="tariff.id"
                        v-for="tariff in tariffs"
                >
                    <template v-if="tariff.description">
                        <div class="rad">
                            <input
                                    type="radio"
                                    class="rad__input"
                                    :id="'tariff_select_' + tariff.id"
                                    :value="tariff.id"
                                    v-model="selectedTariffId"
                            >
                            <label
                                    :for="'tariff_select_' + tariff.id"
                                    class="rad__label"
                            >{{ tariff.name }}</label>
                        </div>
                        <div class="nums__price" v-html="formatTariffPrice(tariff.description)"></div>
                    </template>
                    <template v-else>
                        <div class="rad nums__grow">
                            <input
                                    type="radio"
                                    class="rad__input"
                                    :id="'tariff_select_' + tariff.id"
                                    :value="tariff.id"
                                    v-model="selectedTariffId"
                            >
                            <label
                                    :for="'tariff_select_' + tariff.id"
                                    class="rad__label"
                            >{{ tariff.name }}</label>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div
                class="nums__popup-footer"
                v-if="isTariffSelected"
        >
            <div class="container">
                <Button
                        size="button button--md"
                        title="Выбрать тариф"
                        :defaultClass="false"
                        @click="submit"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Button from '../../../components/ui/Button.vue';
import ModelProvider from '../../numbers-page/models/provider.js';
import ModelTariff from '../../numbers-page/models/tariff.js';
import message from '../../../lib/message.js'

export default {
    name: "SelectTariffModalMobile",
    components: {
        Button
    },
    props: {
        provider: {
            type: ModelProvider
        },
        tariffs: {
            type: Array
        },
        selectedTariff: {
            type: ModelTariff
        },
        selectTariffFunction: {
            type: Function
        }
    },
    data () {
        return {
            selectedTariffId: null
        }
    },
    computed: {
        selectedId () {
            let grouped = {};
            if (Array.isArray(this.selectedBranches)) {
                this.selectedBranches.forEach(branch => {
                    grouped[branch.id] = true;
                })
            }
            return grouped;
        },
        displayBranches () {
            let branches = this.branches;
            if (Array.isArray(branches)) {
                return branches.filter(branch => !this.selectedId[branch.id])
            }
            return [];
        },
        filteredBranches () {
            if (this.query) {
                let regexp = new RegExp(this.query, 'i');
                return this.displayBranches.filter(branch => regexp.test(branch.name))
            }
            return this.displayBranches;
        },
        isTariffSelected () {
            return this.selectedTariffId !== null;
        }
    },
    mounted () {
        if (this.selectedTariff) {
            this.selectedTariffId = this.selectedTariff.id
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        submit () {
            let tariff = this.tariffs.find(tariff => tariff.id === this.selectedTariffId);
            if (!tariff) {
                message.showError('Выберите тариф');
                return;
            }

            if (this.selectedTariff && this.selectedTariff.id === tariff.id) {
                this.close();
                return;
            }

            this.selectTariffFunction(tariff);
            this.close();
        },
        formatTariffPrice (string) {
            return '<b>' + string.replace(/[^0-9, ]/g, '') + '</b> '
                + '<span class="nums__units">' + string.replace(/[0-9]/g, '') + '</span>';
        }
    }
}
</script>

<style lang="scss">

</style>
